import { defineComponent as _defineComponent } from 'vue'
import { TUIGlobal } from "@tencentcloud/chat-uikit-engine";
import {
  ref,
  defineProps,
  defineEmits,
  watch,
  nextTick,
} from "../../../adapter-vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  // 是否展示 底部弹出对话框
  show: {
    type: Boolean,
    default: false,
  },
  // 是否需要遮罩层，默认为true
  modal: {
    type: Boolean,
    default: true,
  },
  // 弹出框内容区域高度(不包含遮罩), 默认为 fit-content
  height: {
    type: String,
    default: "fit-content",
  },
  // 是否可以通过点击外部关闭弹出对话框, 默认为true
  // uniapp 仅支持点击蒙版关闭弹出对话框
  closeByClickOutside: {
    type: Boolean,
    default: true,
  },
},
  emits: ["onOpen", "onClose"],
  setup(__props, { emit: emits }) {

const props = __props





const isPC = ref(TUIGlobal.getPlatform() === "pc");
const isUniFrameWork = ref(typeof uni !== 'undefined');
const dialogRef = ref();

watch(
  () => props.show,
  (newVal: boolean, oldVal: boolean) => {
    if (newVal === oldVal) {
      return;
    }
    switch (newVal) {
      case true:
        emits("onOpen", dialogRef);
        nextTick(
          () => props.closeByClickOutside && onClickOutside(dialogRef.value)
        );
        break;
      case false:
        emits("onClose", dialogRef);
        removeClickListener(dialogRef.value);
        break;
    }
  }
);

// click outside
let clickOutside = false;
let clickInner = false;
const onClickOutside = (component: any) => {
  if (isUniFrameWork.value) {
    return;
  }
  document.addEventListener("mousedown", onClickDocument);
  component?.addEventListener &&
    component?.addEventListener("mousedown", onClickTarget);
};

const onClickDocument = () => {
  clickOutside = true;
  if (!clickInner && clickOutside) {
    emits("onClose", dialogRef);
    removeClickListener(dialogRef.value);
  }
  clickOutside = false;
  clickInner = false;
};

const onClickTarget = () => {
  clickInner = true;
};

const removeClickListener = (component: any) => {
  if (isUniFrameWork.value) {
    return;
  }
  document.removeEventListener("mousedown", onClickDocument);
  component?.removeEventListener &&
    component?.removeEventListener("mousedown", onClickTarget);
};

const onUniClickModal = () => {
  if (isUniFrameWork.value) {
    emits("onClose", dialogRef);
  }
};

return { __sfc: true,props, emits, isPC, isUniFrameWork, dialogRef, clickOutside, clickInner, onClickOutside, onClickDocument, onClickTarget, removeClickListener, onUniClickModal }
}

})